import React, { useEffect, useState } from "react";
import ProductCard from "../components/ProductCard";
import { Reveal } from "../components/motion";
import { fetchProducts } from "../lib/shop";

const FILTERS = [
  { key: "all", label: "ALL" },
  { key: "Hoodies", label: "HOODIES" },
  { key: "Tees", label: "TEES" },
  { key: "Sweatshirts", label: "SWEATSHIRTS" },
  { key: "Headwear", label: "HEADWEAR" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetchProducts().then(setProducts).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  const shown = filter === "all" ? products : products.filter((p) => p.category === filter);

  return (
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 pt-40 md:pt-48 pb-24 md:pb-36 min-h-screen">
      <Reveal className="mb-12">
        <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] text-ash uppercase mb-4">The full range</p>
        <h1 className="font-display font-extrabold uppercase tracking-tighter leading-[0.92] text-5xl sm:text-6xl lg:text-7xl">
          SHOP ALL
        </h1>
        <p className="text-ash text-sm md:text-base mt-5 max-w-md leading-relaxed">
          Heavyweight essentials, exclusively made in London. Free UK delivery over £75, 14-day returns on everything.
        </p>
      </Reveal>

      <div className="flex flex-wrap gap-2 mb-12 border-t border-b border-white/10 py-4 sticky top-[104px] bg-ink/90 backdrop-blur-xl z-30" data-testid="shop-filter-tabs">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            className={`font-mono text-[10px] md:text-[11px] tracking-[0.18em] px-4 py-2.5 transition-colors duration-300 ${
              filter === f.key ? "bg-bone text-ink" : "text-ash hover:text-bone border border-white/15 hover:border-white/40"
            }`}
            data-testid={`product-category-filter-${f.key.toLowerCase()}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-12 md:gap-x-6">
        {shown.length > 0
          ? shown.map((p, i) => <ProductCard key={p.handle} product={p} index={i} />)
          : [...Array(6)].map((_, i) => <div key={i} className="aspect-[4/5] bg-card animate-pulse" />)}
      </div>
    </div>
  );
}
